import upperFirst from 'lodash/upperFirst'

import { GraphStackResponse } from 'src/api/gen'
import { formatDateExport, IOutput, spreadBy } from 'src/commons/export/Export'
import { getTranslation } from 'src/commons/i18n'
import { enumsTranslationKeys } from 'src/commons/i18nEnums'
import { GranularityEnum } from 'src/commons/types'

function translatePolicyKind() {
  const { t } = getTranslation()
  return (policyKind: string) => upperFirst(t(enumsTranslationKeys.PolicyKind[policyKind] || policyKind))
}

export function formatExportOffensesPerKindPerDate(granularity: GranularityEnum, percentMode: boolean) {
  const { t } = getTranslation()
  return (bucket: GraphStackResponse): IOutput => ({
    [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
    ...spreadBy(bucket.stackedBy.buckets, percentMode ? '(%)' : '', true, translatePolicyKind()),
  })
}
